<template>
  <v-card width="300" class="d-flex text-center text-h5 py-5">
    <v-menu offset-y max-height="300px">
      <template v-slot:activator="{ on, attrs }">
        <div
          style="min-width: 49%"
          class="flex-grow-1"
          v-on="on"
          v-bind="attrs"
        >
          {{ hour }}
        </div>
      </template>
      <v-list>
        <v-list-item-group v-model="hour" color="primary">
          <v-list-item
            v-for="i in hourRange"
            :key="i"
            class="text-center"
            :value="i"
          >
            <v-list-item-title class="text-h6">{{
              padString(i)
            }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <div class="flex-grow-1">:</div>
    <v-menu offset-y max-height="300px">
      <template v-slot:activator="{ on, attrs }">
        <div
          style="min-width: 49%"
          class="flex-grow-1"
          v-on="on"
          v-bind="attrs"
        >
          {{ minute }}
        </div>
      </template>
      <v-list>
        <v-list-item-group v-model="minute" color="primary">
          <v-list-item
            v-for="i in minuteRange"
            :key="i"
            class="text-center"
            :value="i"
          >
            <v-list-item-title>{{ padString(i) }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </v-card>
</template>

<script>
export default {
  name: 'TimePickerBoard',
  props: {
    value: String,
    minuteStep: {
      type: [String, Number],
      default: 5,
    },
  },
  computed: {
    hour: {
      get() {
        return Number(String(this.value || '00:00').split(':')[0] || 0);
      },
      set(h) {
        const fullTime = `${String(h).padStart(2, '0')}:${String(
          this.minute,
        ).padStart(2, '0')}`;
        this.$emit('input', fullTime);
      },
    },
    minute: {
      get() {
        return Number(String(this.value || '00:00').split(':')[1] || 0);
      },
      set(m) {
        const fullTime = `${String(this.hour).padStart(2, '0')}:${String(
          m,
        ).padStart(2, '0')}`;
        this.$emit('input', fullTime);
      },
    },
    hourRange() {
      return [...Array(24).keys()];
    },
    minuteRange() {
      return [...Array(60 / this.minuteStep).keys()].map(
        (i) => i * this.minuteStep,
      );
    },
  },
  methods: {
    padString(str, length = 2) {
      return String(str).padStart(length, '0');
    },
  },
};
</script>

<style scoped></style>
